import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const SearchFilter = ({ onSearch, onClear, children }) => {
  return (
    <>
      {children}

      <div className="row">
        <div className="col d-flex justify-content-end">
          <button type="button" className="btn btn-link" onClick={onClear}>
            <FormattedMessage
              id="management-search-clear"
              defaultMessage="Tyhjennä"
            />
          </button>

          <button
            type="button"
            className="btn btn-primary ml-3"
            onClick={onSearch}
          >
            <i className="fas fa-search mr-3" />
            <FormattedMessage
              id="management-search-search"
              defaultMessage="Hae"
            />
          </button>
        </div>
      </div>
    </>
  );
};

SearchFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default SearchFilter;
